import React from 'react';
import parse from 'html-react-parser';

type Props = {
    text: string;
    title?: string;
};

export default function MTaskText({ text, title }: Props) {
    return (
        <React.Fragment>
            <div className={title ? 'task-text' : 'task-text task-text--standalone'}>{parse(text)}</div>
        </React.Fragment>
    );
}
